import { useAppSelector } from "@hooks";
export function useCheckAccess(roles) {
    const { currentUser } = useAppSelector((state) => state.users);
    if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roles) !== null) {
        return currentUser === null || currentUser === void 0 ? void 0 : currentUser.roles.some((item) => roles.includes(item.roleName));
    }
    return false;
}
